import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import RoxyOrb from './Roxy/RoxyOrb';
import { roxyStateWord } from './Roxy/roxyStates';

const ChatHeader = ({ applicationName, sessionId, roxyState, hasClosedChats, showHistory, onClose, onToggleHistory }) => (
    <>
        <div className="roxy-panel__header">
            <RoxyOrb state={roxyState} size={58} className="roxy-panel__avatar" />
            <div className="roxy-panel__identity">
                <span className="roxy-panel__title">ROXY</span>
                <span className="roxy-panel__status">{roxyStateWord(roxyState)}</span>
            </div>
            <IconButton onClick={onClose} size="small" className="roxy-panel__close-btn" aria-label="Close Roxy">
                <CloseIcon />
            </IconButton>
        </div>
        <div className="roxy-panel__subheader">
            <span className="roxy-panel__subtitle">
                {applicationName}{sessionId ? ` · session #${sessionId}` : ''}
            </span>
            {hasClosedChats && (
                <button type="button" className="roxy-panel__history-btn" onClick={onToggleHistory}>
                    {showHistory ? 'Back to Chat' : 'Closed Chats'}
                </button>
            )}
        </div>
    </>
);

export default ChatHeader;
